import { defineMessages } from 'react-intl'

const scope = `procurify.components.ExpenseTypeSummary`

export default defineMessages({
  ticketNumberLabel: {
    id: `${scope}.ticketNumberLabel`,
    defaultMessage: 'Ticket number',
  },
  departureDateLabel: {
    id: `${scope}.departureDateLabel`,
    defaultMessage: 'Departure date',
  },
  arrivalDateLabel: {
    id: `${scope}.arrivalDateLabel`,
    defaultMessage: 'Arrival date',
  },
  airlineLabel: {
    id: `${scope}.airlineLabel`,
    defaultMessage: 'Airline',
  },
  hourlyRateLabel: {
    id: `${scope}.hourlyRateLabel`,
    defaultMessage: 'Hourly rate',
  },
  hoursOfWorkLabel: {
    id: `${scope}.hoursOfWorkLabel`,
    defaultMessage: 'Hours of work',
  },
  tipsLabel: {
    id: `${scope}.tipsLabel`,
    defaultMessage: 'Tips',
  },
  mileageRateLabel: {
    id: `${scope}.mileageRateLabel`,
    defaultMessage: 'Rate',
  },
  distanceLabel: {
    id: `${scope}.distanceLabel`,
    defaultMessage: 'Distance',
  },
  subtotalLabel: {
    id: `${scope}.subtotalLabel`,
    defaultMessage: 'Subtotal',
  },
  itemLabel: {
    id: `${scope}.itemLabel`,
    defaultMessage: 'Item',
  },
  itemWithTypeLabel: {
    id: `${scope}.itemWithTypeLabel`,
    defaultMessage: '{expenseType} item',
  },
  advisoryFuelRateLabel: {
    id: `${scope}.advisoryFuelRateLabel`,
    defaultMessage: 'Advisory fuel rate',
  },
  customRateLabel: {
    id: `${scope}.customRateLabel`,
    defaultMessage: 'Custom rate',
  },
})
